
import { 
  SAVE_SHAREDMAILBOXES, 
  FETCH_SHAREDMAILBOXES, 
  SHAREDMAILBOX_FETCH_FAILED
} from './types';
import { 
  UPDATE_SM_INIT,
  UPDATE_SM_FAILED,
  UPDATE_SM_DONE
} from '../../common/actions';
import { HiverAxios, setHiddenLoadingBar, getIntegersParsedObject } from 'h-commons';
import keys from 'lodash/keys';
import { GET_CHANNELS_INBOXES } from '../../../channelAdmin/constants/channelAdminAPI.const';

const SM_ROOT = '/gx/api/sm';
const SM_FETCH_FAIL = 'Fetching of sm failed';
/**
 * Action dispatched before making the request
 */
function fetchSMs() {
  return {
    type: FETCH_SHAREDMAILBOXES
  };
}


/**
 * Returns object mapping of sms
 * @param map sms 
 */
function getSms(sms) {
  return keys(sms).reduce((prev, curr) => ({ 
    ...prev, [sms[curr].id]: sms[curr]
  }), {});
}

/**
 * Responsible for fetching sharedmailbox's present for the loggedin user
 */
export function fetchMailboxes(hiddenRequest, integrations, onSuccess) {
  if (Array.isArray(integrations) && integrations.some((integration)=> integration)) {
    return (dispatch) => {
      hiddenRequest && dispatch(setHiddenLoadingBar(true));
      dispatch(fetchSMs());
      HiverAxios({
        url: GET_CHANNELS_INBOXES.url,
        type: GET_CHANNELS_INBOXES.type,
        params: {},
        callback: (response) => {
          dispatch({
            type: SAVE_SHAREDMAILBOXES,
            payload: formatMailboxes(response.data),
          });
          if (typeof onSuccess === 'function') {
            onSuccess(formatMailboxes(response.data));
          }
          hiddenRequest && dispatch(setHiddenLoadingBar(false));
        },
        onfail: () => {
          dispatch({
            type: SHAREDMAILBOX_FETCH_FAILED,
            payload: SM_FETCH_FAIL,
          });
          hiddenRequest && dispatch(setHiddenLoadingBar(false));
        },
      });
    };
  }
  return (dispatch) => {
    HiverAxios({
      url: SM_ROOT,
      type: 'get',
      params: {},
      callback: (response) => {
          dispatch({
            type: SAVE_SHAREDMAILBOXES,
            payload: response.data.data,
          });
          if (onSuccess) {
            onSuccess();
          }
          hiddenRequest && dispatch(setHiddenLoadingBar(false));
      },
      onfail: () => {
        dispatch({
          type: SHAREDMAILBOX_FETCH_FAILED,
          payload: SM_FETCH_FAIL,
        });
        hiddenRequest && dispatch(setHiddenLoadingBar(false));
      },
    });
  };
}

const formatMailboxes = (data) => {
  const inboxes = {};
  const allInboxes = data.inboxes;
  allInboxes.forEach( inbox => {
    if(inbox.channel == 'email'){
      const { active, ga_group_email, groups, isgagroup, sm_email_id, source_auth, source_email} = inbox.email_properties;
      const inboxData = {
        display_name: inbox.name,
        id: inbox.id,
        users: inbox.userCount,
        active,
        gagroupemail: ga_group_email,
        groups,
        isgagroup,
        smEmailId: sm_email_id,
        sourceAuth: source_auth,
        source_email,
        channel: inbox.channel,
        created_at: inbox.created_at,
      };
      inboxes[inbox.id] = inboxData;
    } else if(inbox.channel == 'chat'){
      const inboxData = {
        display_name: inbox.name,
        id: inbox.id,
        users: inbox.users_count,
        channel: inbox.channel,
        created_at: inbox.created_at,
      };
      inboxes[`chat_${inbox.id}`] = inboxData;
    } else if (inbox.channel == 'whatsapp') {
      const inboxData = {
        display_name: inbox.name,
        id: inbox.id,
        users: inbox.users_count,
        channel: inbox.channel,
        created_at: inbox.created_at,
        whatsapp_settings : inbox.whatsapp_settings
      };
      inboxes[`whatsapp_${inbox.id}`] = inboxData;
    } else if(inbox.channel == 'aircall'){
      const inboxData = {
        display_name: inbox.name,
        id: inbox.id,
        users: inbox.userCount,
        active: inbox.voice_properties.active,
        channel: inbox.channel,
        created_at: inbox.created_at,
      };
      inboxes[`voice_${inbox.id}`] = inboxData;
    }
  });
  return inboxes;
}
export function fetchInboxes(hiddenRequest) {
  return (dispatch) => {
    hiddenRequest && dispatch(setHiddenLoadingBar(true));
    dispatch(fetchSMs());
    HiverAxios({
      url: SM_ROOT,
      type: 'get',
      params: {},
      callback: (response) => {
        dispatch({
          type: SAVE_SHAREDMAILBOXES,
          payload: response.data.data
        });
        hiddenRequest && dispatch(setHiddenLoadingBar(false));
      },
      onfail: () => {
        dispatch({
          type: SHAREDMAILBOX_FETCH_FAILED,
          payload: SM_FETCH_FAIL
        });
        hiddenRequest && dispatch(setHiddenLoadingBar(false));
      }
    });
  };
}
export function fetchMailboxById(id, hiddenRequest) {
  return (dispatch) => {
    hiddenRequest && dispatch(setHiddenLoadingBar(true));
    dispatch({
      type: UPDATE_SM_INIT
    });
    HiverAxios({
      url: `${SM_ROOT}/${id}`,
      type: 'get',
      params: {},
      callback: (response) => {
        dispatch({
          type: UPDATE_SM_DONE,
          payload: getIntegersParsedObject(response.data)
        });
        hiddenRequest && dispatch(setHiddenLoadingBar(false));
      },
      onfail: () => {
        dispatch({
          type: UPDATE_SM_FAILED,
          payload: `Failed to load sharedmailbox ${id}`
        });
        hiddenRequest && dispatch(setHiddenLoadingBar(false));
      }
    });
  };
}
